<template>
    <view class="offline-mask" v-if="publicStore.isOffline">
        <view class="offline-card">
            <!-- loading -->
            <view class="loading" v-if="loading"></view>

            <!-- 文案 -->
            <text class="title">{{ !loading ? '网络连接失败' : '网络连接中' }}</text>

            <!-- 按钮 -->
            <view class="btn-group" v-if="!loading">
                <view class="btn" @click="SetUpNetwork">配置网络</view>
                <view class="btn" @click="retry">刷新重连</view>
            </view>
        </view>
    </view>
</template>

<script setup>
    import { ref } from 'vue';
    import { usePublicStore } from '@/stores/public';

    const publicStore = usePublicStore();
    const loading = ref(false);

    // 跳设置
    const SetUpNetwork = () => {
        // #ifdef APP-PLUS
        if (plus.os.name === 'Android') {
            try {
                const main = plus.android.runtimeMainActivity();
                const Intent = plus.android.importClass('android.content.Intent');
                const Settings = plus.android.importClass('android.provider.Settings');

                const intent = new Intent(Settings.ACTION_WIFI_SETTINGS);
                main.startActivity(intent);
            } catch (e) {
                console.log('打开设置失败', e);
            }
        } else {
            plus.runtime.openURL('App-Prefs:root=WIFI');
        }
        // #endif
    };

    // 刷新重连
    const retry = () => {
        loading.value = true;

        uni.getNetworkType({
            success: (res) => {
                const isOffline = res.networkType === 'none';
                publicStore.setOffline(isOffline);
                if (isOffline) {
                    setTimeout(() => {
                        loading.value = false;
                    }, 800);
                }
            }
        });
    };
</script>

<style scoped>
    .offline-mask {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 9999;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .offline-card {
        width: 420px;
        padding: 40px 30px;
        background: #fff;
        border-radius: 16px;
        text-align: center;
    }

    /* loading 圆圈 */
    .loading {
        width: 60px;
        height: 60px;
        margin: 0 auto 20px;
        border: 6px solid #ddd;
        border-top-color: #409eff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .title {
        font-size: 28px;
        color: #666;
        margin-bottom: 30px;
    }

    .btn-group {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }

    .btn {
        flex: 1;
        margin: 0 10px;
        height: 50px;
        line-height: 50px;
        background: #409eff;
        color: #fff;
        border-radius: 10px;
    }
</style>
